/* eslint-disable */
import React from 'react';
import { Grid } from '@mui/material';
import useStyles from './OneHalfImage.styles';
import { Contentful, FrontifyImageContent } from '../../contentful';
import { ButtonContent } from '../OldButton/OldButton';
import Button from '../OldButton/OldButton';
import { setImgWidth } from '../../utils/frontify';

export interface OneHalfImageContent extends Contentful {
  fields: {
    title: string;
    subtitle: string;
    body: string;
    image: FrontifyImageContent[];
    ctaButton: ButtonContent;
    imageAlignment: 'left' | 'right';
  };
}

interface Props {
  content: OneHalfImageContent;
}

/**
 * @deprecated V2 component
 */
export default function OneHalfImage({ content }: Props) {
  const { title, subtitle, body, image, ctaButton, imageAlignment } =
    content.fields;
  const imageUrl = image[0].preview_url;
  const { classes } = useStyles();

  return (
    <Grid
      container
      style={{
        flexDirection: imageAlignment === 'left' ? 'row' : 'row-reverse',
      }}
      className={classes.container}
    >
      <Grid
        className={classes.section}
        style={{
          backgroundImage: `url('${setImgWidth(imageUrl, 1440)}')`,
        }}
        item
        lg={6}
        xs={12}
      />
      <Grid item lg={6} xs={12} className={classes.textContainer}>
        <h1 className={classes.title}>{title}</h1>
        {subtitle && <h2 className={classes.subtitle}>{subtitle}</h2>}
        {body &&
          body.split('\n').map((txt, index) => (
            <p key={txt + index} className={classes.body}>
              {txt.length === 0 ? '\xA0' : txt}
            </p>
          ))}
        {ctaButton && (
          <div className={classes.buttom}>
            <Button {...ctaButton?.fields} />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
